import {
  ExportOutlined,
  KeyOutlined,
  LoadingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  message as alert,
  Row,
  Select,
  Table,
} from "antd";
import React, { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useDispatch, useSelector } from "react-redux";
import NotNeedAuthService from "../../../Services/notNeedAuth.service";
import { validateConcurrentLogin } from "../../../Actions/api";
import "./css/product.css";
import jwt_decode from "jwt-decode";

function Token(props) {
  useEffect(() => {
    for(let i = 0; i < props.APPIdInfo.length; i++){
      var array = props.APPIdInfo[i].productAccount.split(",");
      // console.log(array);
      for(let j = 0; j < array.length; j++){
        var newString = array[j].replace(/\s/g, "-");
        // console.log(newString);
        if(newString === props.categoryName){
          form.setFieldsValue({
            appId: props.APPIdInfo[i].value,
            apiKey: props.APPIdInfo[i].apiKey,
          });
        }
      }
    }

  }, [props.APPIdInfo]);

  const [form] = Form.useForm();
  const [tokenForm] = Form.useForm();
  const { Option } = Select;
  const { message } = useSelector((state) => state.message);
  const [loading, setLoading] = useState(false);
  const [display, setDisplay] = useState(false);
  const [data, setData] = useState("");
  const dispatch = useDispatch();
  const info = () => {
    handleConcurrentLogin(props.token);
    alert.success("Copy Success");
  };
  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };

  useEffect(() => {
    setLoading(false);
    if (message) {
    }
  }, [message]);

  const handleAPIAccountChange = (value) => {
    for (var i = 0; i <= props.APPIdInfo.length - 1; i++) {
      var apiUserName = props.APPIdInfo[i].value;
      var apiKey = props.APPIdInfo[i].apiKey;
      if (apiUserName === value) {
        form.setFieldsValue({
          apiKey: apiKey,
        });
      }
    }
  };

  const handleConcurrentLogin = (token) => {
    if (token !== undefined) {
      let concurrencyLoginStamp = localStorage.getItem('ConcurrencyLoginStamp');
      if (token && concurrencyLoginStamp) {
        var decodePayload = jwt_decode(token);
        dispatch(validateConcurrentLogin(decodePayload.uid, concurrencyLoginStamp));
      }
    }
  }

  const handleGenerateToken = (values) => {
    setLoading(true);
    handleConcurrentLogin(props.token);
    NotNeedAuthService.generateToken(values.appId, values.apiKey).then(
      (data) => {
        setDisplay(true);
        setData(data.data.Content);
        tokenForm.setFieldsValue({
          token: data.data.Content,
        });
        setLoading(false);
      }
    );
  };

  const columns = [
    {
      title: "No",
      dataIndex: "key",
    },
    {
      title: "APP ID",
      dataIndex: "apiUserName",
      key: "apiUserName",
    },
    {
      title: "Secret Key",
      dataIndex: "apiKey",
      key: "apiKey",
      width: "30%",
    },
    {
      title: "Product Account",
      dataIndex: "productAccount",
      key: "productAccount",
      width: "40%",
    }
  ];
  return (
    <div>
      <p className="product_doc_title">Generate Token</p>
      <Form
        {...layout}
        form={form}
        layout="vertical"
        name="basic"
        className="form_token"
        onFinish={handleGenerateToken}
      >
        <Row gutter={24}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item label={<label className="label_login">App ID</label>}>
              <Input.Group compact size="large">
                <div className="icon_selection">{<UserOutlined />}</div>
                <Form.Item
                  name="appId"
                  className="inputSelection"
                  rules={[
                    {
                      required: true,
                      message: "Please input your App ID!",
                    },
                  ]}
                >
                  <Select
                    size="large"
                    onChange={handleAPIAccountChange}
                    style={{ width: "100%" }}
                  >
                    {props.APPIdInfo.map((c) => (
                      <Option key={c.value}>{c.label}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Input.Group>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item
              label={<label className="label_login">Secret Key</label>}
              name="apiKey"
              rules={[
                {
                  required: true,
                  message: "Please input your Secret Key!",
                },
              ]}
            >
              <Input
                size="large"
                addonBefore={<KeyOutlined />}
                readOnly
                placeholder=""
              />
            </Form.Item>
          </Col>
        </Row>
        <br />
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            className="button_login"
          >
            {loading && <LoadingOutlined />}
            GENERATE
          </Button>
        </Form.Item>
      </Form>
      {display && (
        <Row gutter={24}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Form {...layout} form={tokenForm} layout="vertical" name="basic">
              <Row>
                <Col span={23}>
                  <Form.Item
                    label={<label className="label_login">Token</label>}
                    name="token"
                  >
                    <Input
                      size="large"
                      readOnly
                      addonBefore={<ExportOutlined />}
                    />
                  </Form.Item>
                </Col>
                <Col span={1} style={{ marginTop: "33px" }}>
                  <CopyToClipboard text={data}>
                    <Button type="primary" size="large" onClick={info}>
                      <ExportOutlined />
                    </Button>
                  </CopyToClipboard>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      )}
      <Divider />
      <div>
        <p className="product_doc_title">APIs Sandbox - ID & Key</p>
        <br />
        <Table
          columns={columns}
          dataSource={props.APIAccountInfo}
          scroll={{ x: "fit-content" }}
          rowKey={"apiUserName"}
        />
      </div>
    </div>
  );
}
export default Token;
